import { GeocoderException } from './geocoder.exception';

export class InvalidServerResponseException extends GeocoderException {}
